import React from 'react';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';

const stateColors = {
  Erstellt: '#6d6d69',
  Verwendet: '#6d23ed',
  Abgelaufen: '#6e72a3',
  Storniert: '#e85e27',
  'Storniert ohne Payment': '#e85e27',
  Aktiv: '#2c9310',
};

export function OrderStateChip({
  refundOrderWithoutPayment,
  state,
  validFrom,
  validTo,
}) {
  const now = moment();
  const from = moment(validFrom);
  const to = moment(validTo);
  const canceled = state === 'CANCELLED';
  const isActive = now.isBetween(from, to, 'day', '[]');
  const label = refundOrderWithoutPayment
    ? 'Storniert ohne Payment'
    : canceled
      ? 'Storniert'
      : isActive
        ? 'Aktiv'
        : now.isAfter(to)
          ? 'Abgelaufen'
          : 'Erstellt';
  return (
    <Chip
      label={label}
      style={{ backgroundColor: stateColors[label], color: 'white' }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/skidata/components/OrderStateChip.jsx